"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const table_config_1 = require("@app/component/ui/table/table-config");
const util_1 = require("@app/util");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const i18n_1 = require("@app/util/i18n");
const _ui_1 = require("@ui");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_beautiful_dnd_1 = require("react-beautiful-dnd");
const PlanningSetup = ({ closeFn, createPlan, ws, positions, calendarMultiSelect, }) => {
    // ======================================================================================
    // list of supported planner rules - their weights can be overridden by the user
    const supportedPlannerRuleTypes = [
        'unassigned_shifts',
        'unavailability_minutes',
        'availability_minutes',
        'cycle_shifts_overlap_minutes',
        'skill_too_low',
        'skill_too_high',
        'breaks_between_shifts_too_short',
        'work_time_monthly_fund_deviation',
        'shift_start_times',
    ];
    // planner's rule weight overrides
    const [useRuleWeightOverrides, setUseRuleWeightOverrides] = (0, react_1.useState)(false);
    const [formPlanningRuleWeightOverrides, setFormPlanningRuleWeightOverrides] = (0, react_1.useState)({});
    const tableConfigOverridesRuleWeights = [
        {
            key: 'ruleType',
            tlKey: (0, i18n_1.t)('RULE'),
            sortable: false,
            filterable: false,
            rowToHTML: (row) => (react_1.default.createElement(_ui_1.Text, { type: _ui_1.Text.TYPES.BODY_MEDIUM }, (0, i18n_1.t)('PLANNER_RT.' + row.ruleType))),
            rowToStr: (row) => (0, i18n_1.t)('PLANNER_RT.' + row.ruleType),
        },
        {
            key: 'ruleValue',
            tlKey: (0, i18n_1.t)('VALUE'),
            sortable: false,
            filterable: false,
            rowToHTML: (row) => (react_1.default.createElement(_ui_1.Input, { name: 'ruleValue_' + row.ruleType, type: _ui_1.Input.TYPES.NUMBER, value: (0, maybe_unwrap_1.unwrapMaybe)(row.value), min: 0, max: 100, onChange: (v) => {
                    const newValues = Object.assign({}, formPlanningRuleWeightOverrides);
                    let newVal = parseInt(v);
                    if (newVal < 0)
                        newVal = 0;
                    if (newVal > 100)
                        newVal = 100;
                    newValues[row.ruleType] = newVal;
                    setFormPlanningRuleWeightOverrides(newValues);
                }, onFocus: () => {
                    setTimeout(() => {
                        const inputEl = document.getElementById('ruleValue_' + row.ruleType);
                        if (inputEl) {
                            inputEl.focus();
                            document.execCommand('selectAll', false, undefined);
                        }
                    }, 50);
                } })),
            rowToStr: (row) => row.value,
        },
    ];
    // ======================================================================================
    // list of supported planning ordering types
    const orderByOptions = [
        { value: 'allAtOnce', label: (0, i18n_1.t)('PLANNER_ORDER_BY_ALL_AT_ONCE') },
        { value: 'contractType', label: (0, i18n_1.t)('AGREEMENT') },
        { value: 'position', label: (0, i18n_1.t)('POSITION') },
        { value: 'calendarOrder', label: (0, i18n_1.t)('EMPOYEE_PROFILE_CALENDAR_ORDER') },
    ];
    // planning process ordering
    const [formPlanningOrderByType, setFormPlanningOrderByType] = (0, react_1.useState)('allAtOnce');
    const [formPlanningOrderByValues, setFormPlanningOrderByValues] = react_1.default.useState([]);
    // ======================================================================================
    // work hours fund overrides
    const [usePlanningWorkFundOverrides, setUsePlanningWorkFundOverrides] = (0, react_1.useState)(false);
    const [formPlanningWorkFundOverrides, setFormPlanningWorkFundOverrides] = (0, react_1.useState)([]);
    const fundOptions = [
        { value: undefined, label: (0, i18n_1.t)('FOND') },
        { value: 'percent', label: (0, i18n_1.t)('PLANNER_FUND_OVERRIDE_PERCENT') },
        { value: 'absolute', label: (0, i18n_1.t)('PLANNER_FUND_OVERRIDE_ABSOLUTE') },
    ];
    const tableConfigOverridesWorkFund = (0, table_config_1.createNullableTableConfig)([
        {
            key: 'contractType',
            tlKey: ' ',
            sortable: false,
            filterable: false,
            rowToHTML: (row) => (react_1.default.createElement(_ui_1.Text, { type: _ui_1.Text.TYPES.BODY_MEDIUM }, ws?.contractTypes?.find((ct) => ct?.id === row?.contractType)?.name)),
            rowToStr: (row) => ws?.contractTypes?.find((ct) => ct?.id === row?.contractType)?.name,
        },
        {
            key: 'overrideType',
            tlKey: (0, i18n_1.t)('SETTINGS'),
            sortable: false,
            filterable: false,
            rowToHTML: (row) => {
                return (react_1.default.createElement(_ui_1.Dropdown, { disableSort: true, label: null, size: _ui_1.Dropdown.SIZES.SMALL, type: _ui_1.Dropdown.TYPES.VARIABLE, style: _ui_1.Dropdown.STYLES.OUTLINED, options: fundOptions, singleSelect: true, value: fundOptions.find((ot) => ot.value === row.overrideType), onChange: (v) => {
                        let newFPO = [...formPlanningWorkFundOverrides];
                        if ((0, util_1.isNull)(v.value)) {
                            newFPO = newFPO.filter((ov) => ov.contractType !== row.contractType);
                        }
                        else {
                            if (newFPO.some((ov) => ov.contractType === row.contractType)) {
                                newFPO = newFPO.map((ov) => {
                                    if (ov.contractType === row.contractType) {
                                        return Object.assign({}, ov, {
                                            overrideType: v.value,
                                            value: ov.overrideType !== v.value
                                                ? v.value === 'percent'
                                                    ? 100
                                                    : 160
                                                : ov.value,
                                        });
                                    }
                                    else {
                                        return ov;
                                    }
                                });
                            }
                            else {
                                newFPO.push({
                                    contractType: row.contractType,
                                    overrideType: v.value,
                                    value: v.value === 'percent' ? 100 : 160,
                                });
                            }
                        }
                        setFormPlanningWorkFundOverrides(newFPO);
                        setTimeout(() => {
                            const inputEl = document.getElementById('fundOverrideValue' + row.contractType);
                            if (inputEl) {
                                inputEl.focus();
                                document.execCommand('selectAll', false, undefined);
                            }
                        }, 200);
                    } }));
            },
        },
        {
            key: 'value',
            tlKey: (0, i18n_1.t)('VALUE'),
            sortable: false,
            filterable: false,
            rowToHTML: (row) => (0, util_1.isNotNull)(row.overrideType) ? (react_1.default.createElement(_ui_1.Input, { name: 'fundOverrideValue' + row.contractType, type: _ui_1.Input.TYPES.NUMBER, value: row.value, onChange: (v) => {
                    const newFPO = formPlanningWorkFundOverrides.map((ov) => {
                        if (ov.contractType === row.contractType) {
                            return Object.assign({}, ov, {
                                value: parseFloat(v),
                            });
                        }
                        else {
                            return ov;
                        }
                    });
                    setFormPlanningWorkFundOverrides(newFPO);
                } })) : null,
            rowToStr: (row) => row.value,
        },
    ]);
    // ======================================================================================
    // set up some helper vars
    const selectedShifts = (calendarMultiSelect.sourceEvents || []).filter((evt) => typeof evt.available === 'undefined' && !evt.categoryId);
    const data = {
        selectedShifts: selectedShifts.map((s) => s.id),
        period: util_1.calendarUtil.getShortestPeriodCoveringEvents(selectedShifts, 0),
    };
    const howManyStr = data.selectedShifts.length.toString();
    const isSomethingSelected = data.selectedShifts.length > 0;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: 'ds-planning-sidebar-planner-header' },
            react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_16, type: _ui_1.Spacing.TYPES.BOTH },
                react_1.default.createElement(_ui_1.Flex, { justify: _ui_1.Flex.POSITION.SPC_BETWEEN, align: _ui_1.Flex.POSITION.CENTER, stretch: true },
                    react_1.default.createElement(_ui_1.Flex, { direction: _ui_1.Flex.DIRECTION.COLUMN },
                        react_1.default.createElement(_ui_1.Text, null, (0, i18n_1.t)('MULTI_SELECTED') +
                            ': ' +
                            howManyStr +
                            ' ' +
                            (0, i18n_1.t)('MULTI_SEL_SHIFTS_MULTI')),
                        Boolean(data.selectedShifts?.length) && (react_1.default.createElement(_ui_1.Text, null, (0, i18n_1.t)('PERIOD') +
                            ': ' +
                            (0, moment_1.default)(data?.period?.start).format('D.M.') +
                            ' - ' +
                            (0, moment_1.default)(data?.period?.end).format('D.M.')))),
                    react_1.default.createElement(_ui_1.Icon, { color: _ui_1.Icon.COLORS.INHERIT, ico: _ui_1.Icon.ICONS.close1, size: _ui_1.Icon.SIZES.MEDIUM, onClick: () => {
                            closeFn();
                        } })))),
        react_1.default.createElement(_ui_1.Separator, null),
        isSomethingSelected ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_16, type: _ui_1.Spacing.TYPES.BOTH },
                react_1.default.createElement("div", { className: 'ds-planning-sidebar-radios' },
                    react_1.default.createElement(_ui_1.RadioGroup, { options: [
                            {
                                value: false,
                                label: (0, i18n_1.t)('PLANNER_USE_DEFAULT_RULE_WEIGHTS'),
                            },
                            {
                                value: true,
                                label: (0, i18n_1.t)('PLANNER_USE_RULE_WEIGHT_OVERRIDES'),
                            },
                        ], onChange: (v) => {
                            setUseRuleWeightOverrides(v);
                        }, value: useRuleWeightOverrides, disabled: false }))),
            useRuleWeightOverrides && (react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_16, type: _ui_1.Spacing.TYPES.BOTH },
                react_1.default.createElement(_ui_1.Table, { className: 'ds-planning-sidebar-rules', tableName: 'planning-setup-overrides-rule-weights', rows: supportedPlannerRuleTypes.map((ruleType) => {
                        return {
                            ruleType,
                            value: Object.keys(formPlanningRuleWeightOverrides).includes(ruleType)
                                ? formPlanningRuleWeightOverrides[ruleType]
                                : ws.settings.plannerDefaults.ruleWeights
                                    ? ws.settings.plannerDefaults.ruleWeights[ruleType]
                                    : 0,
                        };
                    }), showSelection: false, tableConfig: tableConfigOverridesRuleWeights, pagination: false, showActionBar: false, size: _ui_1.Table.SIZE.SLIM, type: _ui_1.Table.TYPES.LEAN }))),
            react_1.default.createElement(_ui_1.Separator, null),
            react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_16, type: _ui_1.Spacing.TYPES.BOTH },
                react_1.default.createElement("div", { className: 'ds-planning-sidebar-radios' },
                    react_1.default.createElement(_ui_1.RadioGroup, { options: [
                            {
                                value: false,
                                label: (0, i18n_1.t)('PLANNER_USE_DEFAULT_FUNDS'),
                            },
                            {
                                value: true,
                                label: (0, i18n_1.t)('PLANNER_USE_FUND_OVERRIDES'),
                            },
                        ], onChange: (v) => {
                            setUsePlanningWorkFundOverrides(v);
                        }, value: usePlanningWorkFundOverrides, disabled: false }),
                    usePlanningWorkFundOverrides && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_16, type: _ui_1.Spacing.TYPES.VERTICAL }),
                        react_1.default.createElement(_ui_1.Text, { type: _ui_1.Text.TYPES.BODY_MEDIUM, weight: _ui_1.Text.WEIGHTS.BOLD }, (0, i18n_1.t)('PLANNER_FUND_OVERRIDE_LABEL')),
                        react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_8, type: _ui_1.Spacing.TYPES.VERTICAL }),
                        react_1.default.createElement(_ui_1.Table, { className: 'ds-planning-sidebar-fund', tableName: 'planning-setup-overrides-rule-weights', rows: ws.contractTypes
                                .filter((ct) => ct.id !== 'default')
                                // @ts-expect-error idk this outrageous
                                .map((ct) => {
                                const or = formPlanningWorkFundOverrides.find((or) => or.contractType === ct.id);
                                return {
                                    contractType: ct.id,
                                    overrideType: or?.overrideType || null,
                                    value: or?.value || null,
                                };
                            }), showSelection: false, tableConfig: tableConfigOverridesWorkFund, pagination: false, showActionBar: false, size: _ui_1.Table.SIZE.SLIM, type: _ui_1.Table.TYPES.LEAN }))))),
            react_1.default.createElement(_ui_1.Separator, null),
            react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_16, type: _ui_1.Spacing.TYPES.BOTH },
                react_1.default.createElement(_ui_1.Dropdown, { disableSort: true, label: (0, i18n_1.t)('PLANNER_ORDER_BY'), size: _ui_1.Dropdown.SIZES.FULL_WIDTH, type: _ui_1.Dropdown.TYPES.VARIABLE, style: _ui_1.Dropdown.STYLES.OUTLINED, options: orderByOptions, singleSelect: true, value: orderByOptions.find((ot) => ot.value === formPlanningOrderByType), onChange: (v) => {
                        setFormPlanningOrderByType(v.value);
                        if (v.value === 'allAtOnce') {
                            setFormPlanningOrderByValues([]);
                        }
                        if (v.value === 'contractType') {
                            setFormPlanningOrderByValues(ws?.contractTypes
                                ?.filter((ct) => ct?.id !== 'default')
                                ?.map((ct) => {
                                return {
                                    id: ct.id,
                                    label: ct.name,
                                };
                            }));
                        }
                        if (v.value === 'position') {
                            setFormPlanningOrderByValues(positions
                                .filter((p) => !p.archived)
                                .map((p) => {
                                return {
                                    id: p.id,
                                    label: p.name ?? '',
                                };
                            }));
                        }
                        if (v.value === 'calendarOrder') {
                            setFormPlanningOrderByValues([]);
                        }
                    } })),
            formPlanningOrderByType !== 'allAtOnce' &&
                formPlanningOrderByType !== 'calendarOrder' && (react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_16, type: _ui_1.Spacing.TYPES.HORIZONTAL },
                react_1.default.createElement(react_beautiful_dnd_1.DragDropContext, { onDragEnd: ({ destination, source }) => {
                        const reorder = (formPlanningOrderByValues, startIndex, endIndex) => {
                            const result = Array.from(formPlanningOrderByValues);
                            const [removed] = result.splice(startIndex, 1);
                            result.splice(endIndex, 0, removed);
                            return result;
                        };
                        if (!destination)
                            return;
                        setFormPlanningOrderByValues(reorder(formPlanningOrderByValues, source.index, destination.index));
                    } },
                    react_1.default.createElement(react_beautiful_dnd_1.Droppable, { droppableId: 'droppable' }, (provided) => (react_1.default.createElement("div", { ref: provided.innerRef, ...provided.droppableProps }, formPlanningOrderByValues.map((item, index) => (react_1.default.createElement(react_beautiful_dnd_1.Draggable, { key: item.id, index: index, draggableId: item.id }, (provided, _snapshot) => (react_1.default.createElement("div", { ref: provided.innerRef, ...provided.draggableProps, ...provided.dragHandleProps },
                        react_1.default.createElement(_ui_1.Flex, { justify: _ui_1.Flex.POSITION.SPC_BETWEEN, align: _ui_1.Flex.POSITION.CENTER, stretch: true },
                            react_1.default.createElement(_ui_1.Text, { type: _ui_1.Text.TYPES.BODY_LARGE, weight: _ui_1.Text.WEIGHTS.BOLD, color: _ui_1.Text.COLORS.PRIMARY }, item.label),
                            react_1.default.createElement(_ui_1.Icon, { ico: _ui_1.Icon.ICONS.properties, color: _ui_1.Icon.COLORS.PRIMARY }))))))))))),
                react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_16, type: _ui_1.Spacing.TYPES.VERTICAL }))))) : (react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_16, type: _ui_1.Spacing.TYPES.BOTH },
            react_1.default.createElement(_ui_1.Text, null, (0, i18n_1.t)('PLANNER_SELECT_SHIFTS')))),
        react_1.default.createElement(_ui_1.Separator, null),
        react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_16, type: _ui_1.Spacing.TYPES.BOTH },
            react_1.default.createElement(_ui_1.Button, { onClick: () => {
                    createPlan({
                        type: 'selected',
                        data: {
                            selectedShifts: data.selectedShifts,
                            period: data.period,
                            // rule weight overrides
                            planningRuleWeightOverrides: useRuleWeightOverrides &&
                                Object.keys(formPlanningRuleWeightOverrides).length > 0
                                ? Object.keys(formPlanningRuleWeightOverrides).map((k) => {
                                    return {
                                        ruleType: k,
                                        value: parseInt(formPlanningRuleWeightOverrides[k]),
                                    };
                                })
                                : undefined,
                            // planning order settings
                            planningOrderBy: formPlanningOrderByType !== 'allAtOnce'
                                ? formPlanningOrderByType
                                : undefined,
                            planningOrderValues: formPlanningOrderByType !== 'allAtOnce' &&
                                formPlanningOrderByType !== 'calendarOrder'
                                ? formPlanningOrderByValues.map((v) => v.id)
                                : undefined,
                            // work fund overrides
                            planningWorkFundOverrides: usePlanningWorkFundOverrides &&
                                formPlanningWorkFundOverrides.length > 0
                                ? formPlanningWorkFundOverrides
                                : undefined,
                        },
                    });
                }, size: _ui_1.Button.SIZES.FULL, label: (0, i18n_1.t)('SHIFTS_ACTION_AUTOPLAN') + ' (' + howManyStr + ')', color: _ui_1.Button.COLORS.PRIMARY, style: _ui_1.Button.STYLES.CONTAINED, disabled: !data.selectedShifts?.length }))));
};
exports.default = PlanningSetup;
